module.exports = __webpack_public_path__ + "img/logoOBB.9fb3a83b.png";